export default __webpack_public_path__ + "static/media/sun.f3ff7c12.ogg";